import { TranslatableText } from '@dreryk/react-common';
import { TestId, TextEditor } from '@dreryk/react-components';

import { VisitTemplateFormBean, VisitTemplateFormController } from '../VisitTemplateForm.types';

import { StyledVisitTemplateFormTextarea } from './VisitTemplateFormTextarea.styled';

const VISIT_TEMPLATES_FORM_TEXT_EDITOR_MAX_CONTENT_LENGTH = 10000;
const VISIT_TEMPLATES_FORM_TEXT_EDITOR_MAX_HTML_CONTENT_LENGTH = 50000;

type VisitTemplateFormTextEditorProps = Pick<VisitTemplateFormController, 'register' | 'control'> & {
   readonly label: TranslatableText;
   readonly placeholder: TranslatableText;
   readonly fieldName: keyof Omit<VisitTemplateFormBean, 'name'>;
   readonly testId: TestId;
};

export const VisitTemplateFormTextEditor = (props: VisitTemplateFormTextEditorProps): JSX.Element => (
   <StyledVisitTemplateFormTextarea>
      <TextEditor
         controller={props.register(props.fieldName, {
            maxLength: VISIT_TEMPLATES_FORM_TEXT_EDITOR_MAX_CONTENT_LENGTH,
         })}
         label={props.label}
         placeholder={props.placeholder}
         testId={props.testId}
         maxLength={VISIT_TEMPLATES_FORM_TEXT_EDITOR_MAX_CONTENT_LENGTH}
         maxHtmlLength={VISIT_TEMPLATES_FORM_TEXT_EDITOR_MAX_HTML_CONTENT_LENGTH}
      >
         <TextEditor.ModalView
            testId={`${props.testId}ModalView`}
            onChange={(value) => props.control.setValue(props.fieldName, value)}
            initialValue={() => props.control.getValues(props.fieldName)}
            label={props.label}
            placeholder={props.placeholder}
            maxLength={VISIT_TEMPLATES_FORM_TEXT_EDITOR_MAX_CONTENT_LENGTH}
         />
      </TextEditor>
   </StyledVisitTemplateFormTextarea>
);
